import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.n5y_1 = call;
        this.o5y_1 = data.o5m_1;
        this.p5y_1 = data.n5m_1;
        this.q5y_1 = data.q5m_1;
        this.r5y_1 = data.p5m_1;
        this.s5y_1 = data.s5m_1;
      }
      a5k() {
        return this.n5y_1;
      }
      sv() {
        return this.a5k().sv();
      }
      b5k() {
        return this.o5y_1;
      }
      c5k() {
        return this.p5y_1;
      }
      h2o() {
        return this.q5y_1;
      }
      n51() {
        return this.r5y_1;
      }
      u5j() {
        return this.s5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
